var map = {
	"./1AGP.png": 68872,
	"./2AGP.png": 27160,
	"./3AGP.png": 20180,
	"components/Catalog/AGP/img/glass/mt/mtPlusSilver/1AGP.png": 68872,
	"components/Catalog/AGP/img/glass/mt/mtPlusSilver/2AGP.png": 27160,
	"components/Catalog/AGP/img/glass/mt/mtPlusSilver/3AGP.png": 20180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23058;